import React, { useState } from 'react';

import { useQuery } from '@apollo/client';
import { capitalize, isEmpty } from 'lodash';
import moment from 'moment';
import { Alert, Card, CardBody, CardText, CardTitle, Col, Row } from 'reactstrap';

import { Referer, TypeOfLead } from '../../../components/Assignment';
import Loading from '../../../components/Loading/Loading';
import PriceFormatter from '../../../components/PriceFormatter/PriceFormatter';
import auth from '../../../services/Auth';
import opportunityAssigmentRequest from '../../../services/opportunityAssigment/gqlSchema';
import { getAvailabilities } from '../utils/leadsStatus';
import AssignmentContext from './assignment.context';
import AssignmentInfos from './AssignmentInfos';
import LeadNotAssociatedWithTheAgent from './LeadNotAssociatedWithTheAgent';
import LeadPreAffected from './LeadPreAffected';
const PreAffectation = props => {
  const currentContactInfo = auth.getContactInfo();
  const currentLeadId = parseInt(props.match.params.id);
  const { loading, error, data } = useQuery(opportunityAssigmentRequest.Query.opportunityPreAssigment, {
    variables: { id: currentLeadId },
  });

  const [rejected, setRejected] = useState(false);
  const [taken, setTaken] = useState(false);
  const [urlAffaire, setUrlAffaire] = useState(false);
  const value = { rejected, setRejected, taken, setTaken, urlAffaire, setUrlAffaire };

  if (loading || error) {
    if (error) {
      console.error(error);
    }

    return <Loading type={'spinkit'} />;
  }

  // Is lead affected to the current contactInfo ?
  const isCurrentContactInfotMatchLead =
    data.opportunityAssigment && currentContactInfo.id === data.opportunityAssigment.contactsInfo.id;

  // Is the time limit is rechead ?
  const currentTime = moment();
  const endPreAffectation = data.opportunityAssigment && moment(data.opportunityAssigment.endAffectation);
  const leadIsAffectable = currentTime < endPreAffectation;

  console.log(currentTime.format());
  console.log(endPreAffectation.format());
  console.log(currentTime.utc().format());
  console.log(endPreAffectation.utc().format());

  // Is opportunity assigned ?
  const isOpportunityAssigned = data.opportunityAssigment && data.opportunityAssigment.isOpportunityAssigned === true;

  // Lead already affected
  const isLeadAllreadyAffected =
    data.opportunityAssigment &&
    data.opportunityAssigment.externalAffaireId !== null &&
    !isCurrentContactInfotMatchLead;

  const oA = data.opportunityAssigment;

  let message = null;
  let link = null;
  if (!oA || !oA.taken) {
    if (!leadIsAffectable) {
      message = [
        'Désolé, vous arrivez un peu trop tard ! Pour rappel, vous avez 1 heure ouvrée pour accepter un lead.',
      ];
    }

    if (
      !isCurrentContactInfotMatchLead ||
      isLeadAllreadyAffected ||
      (isOpportunityAssigned && data.opportunityAssigment.externalAffaireId === null)
    ) {
      message = [
        'Malheureusement, ce lead a déjà été accepté par un autre conseiller',
        "Pour plus d'informations sur l'attribution des leads :",
      ];
      link = 'https://assets.digitregroup.io/drimki/attribution_drimki_092020.pdf';
    }
  }

  const leadDateTypeSeller = type => {
    switch (type) {
      case 'ON_SALE':
        return 'Bien en vente';
      case 'LESS_THAN_3_MONTHS':
        return 'Moins de trois mois';
      case 'MORE_THAN_6_MONTHS':
        return 'Plus de trois mois';
      case 'DO_NOT_KNOW':
        return 'Ne sait pas';
      case 'UNDER_COMPROMISE':
        return 'Sous compromis';
      default:
        return '-';
    }
  };

  const leadDateTypeBuyer = type => {
    switch (type) {
      case 'ON_SALE':
        return 'Bien en vente';
      case 'LESS_THAN_3_MONTHS':
        return 'Moins de trois mois';
      case 'MORE_THAN_6_MONTHS':
        return 'Plus de trois mois';
      case 'DO_NOT_KNOW':
        return 'Ne sait pas';
      case 'UNDER_COMPROMISE':
        return 'Sous offre';
      default:
        return '-';
    }
  };

  const getOrigineLeadType = originLeadType => {
    switch (originLeadType) {
      case 'BUYER':
        return 'Acheteur';
      case 'NO_INTENT':
      case 'APPLICANT':
      case 'SELLER':
        return 'Vendeur';
      case 'PRO':
        return 'Professionnel';
      default:
        return 'Vendeur';
    }
  };

  const qualification = temp => {
    switch (temp) {
      case 'HOT':
        return 'Souhait de rendez-vous avec un conseiller';
      case 'WARM':
        return '';
      default:
        return '';
    }
  };

  return (
    <AssignmentContext.Provider value={value}>
      <Row>
        <Col sm='12' lg='6' xl='4' className='text-left mt-3'>
          <div>
            <Card>
              {oA && !message ? (
                <CardBody>
                  <CardTitle>
                    <h1>Aperçu du lead</h1>
                  </CardTitle>
                  {oA.opportunity?.appointments && oA.opportunity?.appointments.length > 0 && (
                    <Row className='mt-0 mb-0'>
                      <Col className='col-12'>
                        <CardText className='mb-1'>
                          <h2>
                            <strong>Rendez-vous ToutvaBiens</strong>
                          </h2>
                        </CardText>
                      </Col>
                    </Row>
                  )}
                  <h3>Contact</h3>
                  <hr className='mt-0 mb-2' />
                  <Row className='mt-0 mb-0'>
                    <Col className='col-6'>
                      <CardText className='mb-1'>
                        <strong>Profil</strong>
                      </CardText>
                    </Col>
                    <Col className='col-6'>
                      <CardText className='mb-1'>{getOrigineLeadType(oA.opportunity.originLeadType)}</CardText>
                    </Col>
                  </Row>

                  <Row className='mt-0 mb-0'>
                    <Col className='col-6'>
                      <CardText className='mb-1'>
                        <strong>
                          {oA.opportunity.originLeadType === 'NO_INTENT' ||
                          oA.opportunity.originLeadType === 'APPLICANT'
                            ? "Projet à l'étude"
                            : 'Date du projet'}
                        </strong>
                      </CardText>
                    </Col>
                    <Col className='col-6'>
                      <CardText className='mb-1'>
                        {oA.opportunity.originLeadType === 'SELLER'
                          ? leadDateTypeSeller(oA.opportunity.sellingProject)
                          : oA.opportunity.originLeadType === 'BUYER'
                          ? leadDateTypeBuyer(oA.opportunity.buyingProject)
                          : '-'}
                      </CardText>
                    </Col>
                  </Row>
                  <Row className='mt-0 mb-0'>
                    <Col className='col-6'>
                      <CardText className='mb-1'>
                        <strong>Source</strong>
                      </CardText>
                    </Col>
                    <Col className='col-6'>
                      <CardText className='mb-1'>
                        <Referer referer={oA.opportunity.sources.referer} />
                        {oA.opportunity.agentAssignmentId && <span> (mini-site conseiller)</span>}
                      </CardText>
                    </Col>
                  </Row>
                  {oA.opportunity.callcenter.length > 0 && (
                    <Row className='mt-0 mb-0'>
                      <Col className='col-6'>
                        <CardText className='mb-1'>
                          <strong>Qualification ToutvaBiens par sms</strong>
                        </CardText>
                      </Col>
                      <Col className='col-6'>
                        <CardText className='mb-1'>{qualification(oA.opportunity.callcenter[0].temp)}</CardText>
                      </Col>
                    </Row>
                  )}
                  <Row className='mt-0 mb-0'>
                    <Col className='col-6'>
                      <CardText className='mb-1'>
                        <strong>Type de lead</strong>
                      </CardText>
                    </Col>
                    <Col className='col-6'>
                      <CardText className='mb-1'>
                        <TypeOfLead
                          type={oA.billingType}
                          fullText={true}
                          company={currentContactInfo.company.code}
                          partner={oA.opportunity.sources.referer}
                          opportunity={oA.opportunity}
                        />
                      </CardText>
                    </Col>
                  </Row>
                  {oA.opportunity.referer === 'TVB_RDV' && !isEmpty(oA.opportunity.leadMeeting) && (
                    <Row>
                      <Col>
                        <CardText className='mb-1'>
                          <b>Information RDV :</b>
                          <br />
                          <p>{oA.opportunity.leadMeeting.message}</p>
                          <p>
                            <b>Disponibilités:</b>
                            <br />
                            Semaine: <b>{getAvailabilities(oA.opportunity.leadMeeting.week)}</b>
                            <br />
                            Weekend: <b>{getAvailabilities(oA.opportunity.leadMeeting.weekend)}</b>
                          </p>
                        </CardText>
                      </Col>
                    </Row>
                  )}
                  <h2>Bien</h2>
                  <hr className='mt-0' />
                  <Row className='mt-0 mb-0'>
                    <Col className='col-6'>
                      <CardText className='mb-1'>
                        <strong>Ville</strong>
                      </CardText>
                    </Col>
                    <Col className='col-6'>
                      <CardText className='mb-1'>
                        {oA.opportunity.property.zipcode} {capitalize(oA.opportunity.property.city)}
                      </CardText>
                    </Col>
                  </Row>

                  {oA.opportunity.estimations?.[0] && (
                    <Row className='mt-0 mb-0'>
                      <Col className='col-6'>
                        <CardText className='mb-1'>
                          <strong>Estimation mini</strong>
                        </CardText>
                      </Col>
                      <Col className='col-6'>
                        <CardText className='mb-1'>
                          <PriceFormatter integerOnly={true}>{oA.opportunity.estimations[0].minPrice}</PriceFormatter>
                        </CardText>
                      </Col>
                    </Row>
                  )}

                  {oA.opportunity.estimations?.[0] && (
                    <Row className='mt-0 mb-0'>
                      <Col className='col-6'>
                        <CardText className='mb-1'>
                          <strong>Estimation maxi</strong>
                        </CardText>
                      </Col>
                      <Col className='col-6'>
                        <CardText className='mb-1'>
                          <PriceFormatter integerOnly={true}>{oA.opportunity.estimations[0].maxPrice}</PriceFormatter>
                        </CardText>
                      </Col>
                    </Row>
                  )}

                  <Row className='mt-0 mb-0'>
                    <Col className='col-6'>
                      <CardText className='mb-1'>
                        <strong>Type</strong>
                      </CardText>
                    </Col>
                    <Col className='col-6'>
                      {oA.opportunity.property.type === 'HOUSE' ? 'Maison' : 'Appartement'}
                      {oA.opportunity.property.propertiesType &&
                        oA.opportunity.property.propertiesType.name !== 'Maison' &&
                        oA.opportunity.property.propertiesType.name !== 'Appartement' && (
                          <span> / {oA.opportunity.property.propertiesType.name}</span>
                        )}
                    </Col>
                  </Row>

                  {oA.opportunity.property.surface && (
                    <Row className='mt-0 mb-0'>
                      <Col className='col-6'>
                        <CardText className='mb-1'>
                          <strong>Surface</strong>
                        </CardText>
                      </Col>
                      <Col className='col-6'>
                        <CardText className='mb-1'>
                          <span>
                            {oA.opportunity.property.surface}m<sup>2</sup>
                          </span>
                        </CardText>
                      </Col>
                    </Row>
                  )}

                  {oA.opportunity.property.nb_rooms && (
                    <Row className='mt-0 mb-0'>
                      <Col className='col-6'>
                        <CardText className='mb-1'>
                          <strong>Nbr de pièces</strong>
                        </CardText>
                      </Col>
                      <Col className='col-6'>
                        <CardText className='mb-1'>
                          <span>{oA.opportunity.property.nb_rooms}p</span>
                        </CardText>
                      </Col>
                    </Row>
                  )}

                  <Row>
                    <Col>
                      {!oA.opportunity.owners[0].phone_valid_number && (
                        <Alert color='warning' className='mt-2 mb-2'>
                          <CardText className='mb-0'>
                            <strong>Le numéro semble incorrect</strong>
                          </CardText>
                          <CardText className='mt-0'>
                            Travaillez ce contact par email ou en vous rendant sur place
                          </CardText>
                        </Alert>
                      )}
                      {!isOpportunityAssigned && !data.opportunityAssigment.rejected && !rejected && !message && (
                        <>
                          <Alert color='success' className='mt-2 mb-2'>
                            <CardText className='mb-0'>
                              Pour prendre le lead et découvrir les coordonnées du contact, cliquez ci-dessous.
                            </CardText>
                          </Alert>
                        </>
                      )}
                      <LeadPreAffected lead={data.opportunityAssigment} billingType={oA.billingType} />
                      {(oA.taken || taken) && <AssignmentInfos assignmentId={currentLeadId} />}
                    </Col>
                  </Row>
                </CardBody>
              ) : (
                <CardBody>
                  <CardTitle>
                    <h1>Attribution lead</h1>
                  </CardTitle>
                  <hr className='mt-0' />
                  <LeadNotAssociatedWithTheAgent message={message} link={link} />
                </CardBody>
              )}
            </Card>
          </div>
        </Col>
      </Row>
    </AssignmentContext.Provider>
  );
};

export default PreAffectation;
